import type { FC } from 'react';
import { useEffect } from 'react';
import { setCouponQuickBetsV2 } from '@mwl/core-lib';
import type { PopupClasses } from '@/components/Popup/Popup';
import { Popup } from '@/components/Popup/Popup';
import { useTypedDispatch } from '@/hooks';
import { setShowMobileCoupon } from '@/store';
import { CouponWrapper } from '../CouponWrapper/CouponWrapper';
import type { CouponMobileProps } from './CouponMobile.types';
import styles from './CouponMobile.module.scss';
const popupClasses: PopupClasses = {
  wrapper: styles.popupWrapper,
  container: styles.popupContainer,
  overlay: styles.popupOverlay
};
const CouponMobile: FC<CouponMobileProps> = ({
  isShowPopup
}) => {
  const dispatch = useTypedDispatch();
  const onPopupCloseHandler = () => dispatch(setShowMobileCoupon(false));
  useEffect(() => {
    if (isShowPopup) {
      dispatch(setCouponQuickBetsV2(false));
    }
  }, [dispatch, isShowPopup]);
  return <div className={styles.root} data-sentry-component="CouponMobile" data-sentry-source-file="CouponMobile.tsx">
      <Popup onClose={onPopupCloseHandler} show={isShowPopup} withCloseButton={false} withDragBar radius="none" className={styles.popupRoot} classes={popupClasses} disableScrollOnFocus={false} data-sentry-element="Popup" data-sentry-source-file="CouponMobile.tsx">
        <CouponWrapper onArrowLeftClick={onPopupCloseHandler} isShowLeftArrow data-sentry-element="CouponWrapper" data-sentry-source-file="CouponMobile.tsx" />
      </Popup>
    </div>;
};
export { CouponMobile };